import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FornecedorEstrutura } from 'src/app/models/fornecedor-estrutura';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';

@Component({
  selector: 'app-cadastrar-fornecedor-estrutura-modal',
  templateUrl: './cadastrar-fornecedor-estrutura-modal.component.html',
  styleUrls: ['./cadastrar-fornecedor-estrutura-modal.component.scss']
})
export class CadastrarFornecedorEstruturaModalComponent implements OnInit {
  idFornecedor: number;
  fornecedor: FornecedorEstrutura;

  @ViewChild('logo', {static: false}) logo: ElementRef;
  selectedFile: File;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialogRef: MatDialogRef<CadastrarFornecedorEstruturaModalComponent>,
    private utilitarioService: UtilitarioService,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.idFornecedor = data.idFornecedor;

    if(this.idFornecedor) {
      this.buscarFornecedor();
    }
  }

  ngOnInit(): void {
    this.fornecedor = new FornecedorEstrutura();
  }

  buscarFornecedor() {
    this.carregandoService.mostra('buscarFornecedor');

    this.fornecedorEstruturaService.consultarPorId(this.idFornecedor).subscribe(
      forn => {
        this.fornecedor = forn;

        // this.buscarImagemFornecedor();

        this.carregandoService.esconde('buscarFornecedor');
      },
      err => {
        this.carregandoService.esconde('buscarFornecedor');
        this.notificacaoService.erro(err);
      }
    )
  }

  buscarImagemFornecedor() {
    this.carregandoService.mostra('buscarImagemFornecedor');

    this.fornecedorEstruturaService.consultarImagemPorId(this.idFornecedor).subscribe(
      logo => {
        this.utilitarioService.toBase64ComInicio(logo).then(m => {
          this.fornecedor.logo = m;
          this.carregandoService.esconde('buscarImagemFornecedor');
        }).catch(
          () => {
          this.fornecedor.logo = '';
          this.carregandoService.esconde('buscarImagemFornecedor');
          }
        );
      },
      err => {
        this.carregandoService.esconde('buscarImagemFornecedor');
        this.notificacaoService.erro(err);
      }
    )
  }

  onFileChanged(event) {
    if(event.target.files[0].type !== 'image/png') {
      this.logo.nativeElement.value = null;

      this.notificacaoService.erroMSG('Arquivo inválido, use arquivos com extensão .png');
      return;
    } else {
      this.selectedFile = event.target.files[0];
      this.fornecedor.logo = '';
    }
  }

  excluirArquivo() {
    this.fornecedor.logo = '';
    this.selectedFile = undefined;
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }

  async salvar() {
    this.carregandoService.mostra('salvar');

    if (this.selectedFile) {
      this.fornecedor.logo = (await this.utilitarioService.toBase64(this.selectedFile));
    }

    this.fornecedorEstruturaService.salvar(this.fornecedor).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Fornecedor de estrutura salvo com sucesso!!!');
        this.dialogRef.close(true);
      },
      (erro) => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar()  {
    this.dialogRef.close();
  }
}
